import { useState } from 'react';
import styled from '@emotion/styled';

import { useCapabilityValue } from '../../../store/devices/useCapabilityValue';

import { theme } from '../../../theme/theme';
import { su } from '../../../theme/functions/su';

import { MonoButton } from '../../../components/buttons/MonoButton';
import { TextSmall } from '../../../components/common/text/TextSmall';
import { SpinningIcon } from '../../../components/common/SpinningIcon';

import { iconSpinner } from '../../../theme/icons/interface/spinner/spinner';

export function DeviceSettingsMaintenanceAction(props) {
  const [isLoading, setIsLoading] = useState(false);

  const [, setValue, capabilityObj] = useCapabilityValue({
    deviceId: props.deviceId,
    capabilityId: props.capabilityId,
  });

  return (
    <S.Root>
      <MonoButton
        styleWidth="full"
        styleFlat={true}
        styleColor="blue"
        onPress={() => {
          if (isLoading === true) {
            return;
          }

          setIsLoading(true);
          setValue(true)
            .catch(() => {})
            .finally(() => {
              setIsLoading(false);
            });
        }}
      >
        {isLoading === true ? (
          <SpinningIcon url={iconSpinner} color={theme.color.blue} />
        ) : (
          capabilityObj?.title
        )}
      </MonoButton>

      <TextSmall>{capabilityObj?.desc}</TextSmall>
    </S.Root>
  );
}

function S() {}
DeviceSettingsMaintenanceAction.S = S;

S.Root = styled.div`
  display: grid;
  grid-template-rows: 40px auto;
  grid-gap: ${su(1)};
  margin-bottom: ${su(2)};

  ${TextSmall.S.Root} {
    margin: 0;
    color: ${theme.color.text_body_light};
  }
`;
